var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"brief-notification-card",on:{"click":_vm.handleDelete}},[_c('NotificationCard',{attrs:{"notification":_vm.notification}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }